import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { ensureDailyChallengeForUser, evaluateAndAwardBadges } from '@/lib/gamificationEngine';
import { useGameStore } from '@/stores/gameStore';

export function useBadgeEngine() {
  const user = useAuthStore((state) => state.user);
  const fetchGameState = useGameStore((state) => state.fetchGameState);

  useEffect(() => {
    if (!user) return;

    let active = true;
    const run = async () => {
      await ensureDailyChallengeForUser(user.id);
      await evaluateAndAwardBadges(user.id);
      if (active) await fetchGameState(user.id);
    };

    void run();
    const timer = window.setInterval(() => {
      void run();
    }, 20_000);

    return () => {
      active = false;
      window.clearInterval(timer);
    };
  }, [user, fetchGameState]);
}

